import { createBrowserRouter } from "react-router-dom";
import Main from "../Layout/Main";
import About from "../Pages/About";
import Skills from "../Pages/Skills/Skills";
import Contact from "../Pages/Contact/Contact";
import Portfolio from "../Pages/Portfolio/Portfolio";
import SingleProject from "../Pages/SingleProject/SingleProject";
import PostForm from "../Pages/Post/PostForm";

export const router = createBrowserRouter([
    {
        path:'/',
        element:<Main />,
        children:[
            {
                path:'/',
                element:<About />
                
            },
            {
                path:'/about',
                element:<About />
                
            },
            {
                path:'/post',
                element:<PostForm />
                
            },
            {
                path:'/skills',
                element:<Skills />
                
            },
            {
                path:'/portfolio',
                element:<Portfolio />

            },
            {
                path:'/project/:id',
                element:<SingleProject />,
                
                

            },
            {
                path:'/contact',
                element:<Contact />

            },
        ]
    },
   
])